// @react
import React from 'react'
// @common
import config from 'constants/config'
// @components
import MyATDPageWrapper from 'modules/common/components/MyATDPageWrapper'
import Container from '@bit/atd.web.container'
import SectionMenuWrapper from 'modules/common/components/SectionMenuWrapper'
import Grid from '@bit/atd.web.grid'
import { useMediaQuery } from '@material-ui/core'
import theme from '@bit/atd.web.theme'
import Spacer from '@bit/atd.web.spacer'
import Reminder from 'modules/common/components/Reminder'
import { routes as activityRoutes } from 'modules/activityHistory'
import { useQuery } from '@apollo/client'
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
import { GET_USER } from 'graphql/queries/user.query'

/**
 * 4.0.4 My ATD - Activity History - User Content
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

type PropsType = {
  children: React.ReactNode
}

const ActivityHistory = (props: PropsType) => {
  /******************************************
   * PROPS
   ******************************************/

  const { children } = props

  /******************************************
   * HOOKS
   ******************************************/
  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm'),
    config.mediaQuery,
  )

  /******************************************
   * RENDERS
   ******************************************/

  return (
    <MyATDPageWrapper>
      {/* Sidebar Menu - MOBILE ONLY */}
      {isMobile && (
        <>
          <Grid item xs={12} md={3}>
            <SectionMenuWrapper routeGroup={activityRoutes} />
          </Grid>
        </>
      )}

      <Container>
        <Reminder isHiddenComponent={<Spacer size={!isMobile ? 32 : 24} />} />

        <Grid container spacing={4}>
          {/* Sidebar Menu - DESKTOP ONLY */}
          {!isMobile && (
            <Grid item xs={12} md={3}>
              <SectionMenuWrapper
                user={data?.user}
                routeGroup={activityRoutes}
              />
            </Grid>
          )}

          {/* Content */}
          <Grid item xs={12} md={9}>
            {children}
          </Grid>
        </Grid>
      </Container>
    </MyATDPageWrapper>
  )
}

export default ActivityHistory
